"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forkSporeConfig = exports.getSporeConfig = exports.setSporeConfig = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const predefined_1 = require("./predefined");
let configStore = predefined_1.predefinedSporeConfigs.Aggron4;
/**
 * Set the global default SporeConfig.
 * The default config is "predefinedSporeConfigs.Aggron4".
 */
function setSporeConfig(config) {
    configStore = config;
}
exports.setSporeConfig = setSporeConfig;
/**
 * Get the global default SporeConfig.
 * The default config is "predefinedSporeConfigs.Aggron4".
 */
function getSporeConfig() {
    return configStore;
}
exports.getSporeConfig = getSporeConfig;
/**
 * Clone and create a new SporeConfig.
 */
function forkSporeConfig(origin, change) {
    origin = (0, cloneDeep_1.default)(origin);
    const scripts = {
        ...origin.scripts,
        ...change.scripts,
    };
    return {
        ...origin,
        ...change,
        scripts,
    };
}
exports.forkSporeConfig = forkSporeConfig;
//# sourceMappingURL=config.js.map